import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import authApiService from "../../services/authServices";

const Leaderboard = ({ season, seasonData = [], selectedValue = "", onSeasonChange }) => {
    const [players, setPlayers] = useState([]);

    useEffect(() => {
        const fetchLeaderboardData = async () => {
            try {
                if (season !== "0") { 
                    const response = await authApiService.get("viewLeaderboardPoints", { seasonId: season });

                    if (response && response.data) {
                        setPlayers(response.data);
                    }
                }
            } catch (error) {
                console.error("Error fetching leaderboard data:", error);
            }
        };

        fetchLeaderboardData();
    }, [season]); // Re-fetch data when season changes

    const columns = [
        { name: "POS", selector: (row, index) => index + 1, sortable: true },
        { name: "PLAYER", selector: (row) => row.fullName, sortable: true },
        { name: "PTS", selector: (row) => row.point, sortable: true },
    ];


    const customStyles = {
        table: {
            style: {
                border: "1px solid #ddd",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#40444d", // Black header row
                color: "#ffffff", // White text for header
            },
        },
        rows: {
            style: {
                "&:nth-of-type(odd)": {
                    backgroundColor: "#dedfdd", // Red background for odd rows
                },
                "&:nth-of-type(even)": {
                    backgroundColor: "#ffffff", // White background for even rows
                },
            },
        },
    };

    return (
        <>
            <h2>Leaderboard</h2>
            <form id="leaderboard-form" name="leaderboardForm">
                <select
                    id="division"
                    name="division"
                    value={selectedValue}
                    onChange={onSeasonChange}
                >
                    <option value="0">CHOOSE ANOTHER SEASON</option>
                    {seasonData.length > 0 ? (
                        seasonData.map((seasonOption) => (
                            <option key={seasonOption.id} value={seasonOption.id}>
                                {seasonOption.name}
                            </option>
                        ))
                    ) : (
                        <option disabled>No Record Found</option>
                    )}
                </select>
            </form>
            <div id="leader_rt_sc_div">
                {players.length > 0 ? (
                    <DataTable
                        columns={columns}
                        data={players}
                        noHeader
                        striped
                        highlightOnHover
                        customStyles={customStyles}
                    />
                ) : (
                    <table style={{ width: '100%', border: '1px solid #ddd' }}>
                        <thead>
                            <tr className="activetd" style={{ backgroundColor: '#40444d', color: '#ffffff' }}>
                                <th style={{ padding: '8px 10px', textAlign: 'left' }}>POS</th>
                                <th style={{ padding: '8px 10px', textAlign: 'left' }}>PLAYER</th>
                                <th style={{ padding: '8px 10px', textAlign: 'left' }}>PTS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="odd" style={{ backgroundColor: '#dedfdd' }}>
                                <td style={{ padding: '8px 10px' }}>1</td>
                                <td style={{ padding: '8px 10px' }}></td>
                                <td style={{ padding: '8px 10px' }}></td>
                            </tr>
                            <tr className="even" style={{ backgroundColor: '#ffffff' }}>
                                <td style={{ padding: '8px 10px' }}>2</td>
                                <td style={{ padding: '8px 10px' }}></td>
                                <td style={{ padding: '8px 10px' }}></td>
                            </tr>
                            <tr className="odd" style={{ backgroundColor: '#dedfdd' }}>
                                <td style={{ padding: '8px 10px' }}>3</td>
                                <td style={{ padding: '8px 10px' }}></td>
                                <td style={{ padding: '8px 10px' }}></td>
                            </tr>
                            <tr className="even" style={{ backgroundColor: '#ffffff' }}>
                                <td style={{ padding: '8px 10px' }}>4</td>  
                                <td style={{ padding: '8px 10px' }}></td>
                                <td style={{ padding: '8px 10px' }}></td>
                            </tr>
                            <tr className="odd" style={{ backgroundColor: '#dedfdd' }}>
                                <td style={{ padding: '8px 10px' }}>5</td>
                                <td style={{ padding: '8px 10px' }}></td>
                                <td style={{ padding: '8px 10px' }}></td>
                            </tr>
                            <tr className="even" style={{ backgroundColor: '#ffffff' }}>
                                <td style={{ padding: '8px 10px' }}>6</td>
                                <td style={{ padding: '8px 10px' }}></td>
                                <td style={{ padding: '8px 10px' }}></td>
                            </tr>
                            <tr className="odd" style={{ backgroundColor: '#dedfdd' }}>
                                <td style={{ padding: '8px 10px' }}>7</td>
                                <td style={{ padding: '8px 10px' }}></td>
                                <td style={{ padding: '8px  10px' }}></td>
                            </tr>
                            <tr className="even" style={{ backgroundColor: '#ffffff' }}>
                                <td style={{ padding: '8px 10px' }}>8</td>
                                <td style={{ padding: '8px 10px' }}></td>
                                <td style={{ padding: '8px 10px' }}></td>
                            </tr>
                            <tr className="odd" style={{ backgroundColor: '#dedfdd' }}>
                                <td style={{ padding: '8px 10px' }}>9</td>
                                <td style={{ padding: '8px 10px' }}></td>
                                <td style={{ padding: '8px 10px' }}></td>
                            </tr>
                            <tr className="even" style={{ backgroundColor: '#ffffff' }}>
                                <td style={{ padding: '8px 10px' }}>10</td>
                                <td style={{ padding: '8px 10px' }}></td>
                                <td style={{ padding: '8px 10px' }}></td>
                            </tr>
                        </tbody>
                    </table>
                )}
            </div>
            <div className="buttonwrapper">
                <Link to="/carter/standing" className="squarebutton fill">
                    <span>View Full Leaderboard</span>
                </Link>
            </div>
        </>
    );
};

export default Leaderboard;
